module.exports = __webpack_public_path__ + "static/media/google-partner-logo.f22cf9db.png";